import { PageSection } from 'Components/Layout';
import { useSelector } from 'react-redux';
import { WorkOrderFieldVisibilityGrid } from './Core/OptionalWorkOrderFields';
import { ProductName } from './types';

const QestFieldAdmin = () => {
  const fieldVisibilityValues = useSelector((state: any) => state.admin.syncModel);
  const licensedProducts = useSelector<string[] | null>((state) => state.admin.licensedProducts);

  let qestFieldTestsLabel = 'QESTField Tests';
  let qestFieldTestsDisabled = true;

  if (licensedProducts) {
    if (licensedProducts.includes('QESTField Concrete')) {
      qestFieldTestsDisabled = false;
      qestFieldTestsLabel = licensedProducts.includes('QESTField Tests')
        ? 'QESTField Tests and Concrete'
        : 'QESTField Concrete';
    } else if (licensedProducts.includes('QESTField Tests')) {
      qestFieldTestsDisabled = false;
    }
  }

  return (
    <PageSection heading="Optional Work Order Fields">
      <WorkOrderFieldVisibilityGrid
        Label="QESTField Scheduler"
        Product={ProductName.QestFieldScheduler}
        Data={fieldVisibilityValues}
        Disabled={!licensedProducts?.includes('QESTField Scheduler') ?? true}
      />
      <WorkOrderFieldVisibilityGrid
        Label={qestFieldTestsLabel}
        Product={ProductName.QestFieldTests}
        Data={fieldVisibilityValues}
        Disabled={qestFieldTestsDisabled}
      />
    </PageSection>
  );
};

export default QestFieldAdmin;
export { QestFieldAdmin };
